import { cloneDeep, get, isArray, isEmpty, isNil, sortBy, trim } from 'lodash';

import { sortArrayAttribute } from 'components/customer/external_app_card/lib/sort_array_attribute';

export function applyArraySorts(sourceData, sorts) {
  if (isNil(sourceData) || (isArray(sorts) && isEmpty(sorts))) return sourceData;
  if (!isArray(sorts)) {
    throw Error('applyArraySorts: invalid arguments');
  }

  let workingData = cloneDeep(sourceData);
  const orderedSorts = sortBy(sorts, ['field']);
  orderedSorts.forEach(sortExpr => {
    const path = trim(get(sortExpr, 'field'));
    const sortOrder = trim(get(sortExpr, 'order')).toLowerCase();
    if (!path || !['asc', 'desc'].includes(sortOrder)) {
      throw Error(`applyArraySorts: invalid sort expression "${JSON.stringify(sortExpr)}"`);
    }

    workingData = sortArrayAttribute(workingData, path, sortOrder);
  });

  return workingData;
}
